/**
 * Equivalente ao RC4Crypt do Protheus (AdvPL).
 * decryptLink replica: RC4Crypt(cLink, cKey, .F., .T.) — entrada hex, retorno texto.
 */

function rc4(key: string, input: Uint8Array): Uint8Array {
  const S = new Array<number>(256);
  for (let i = 0; i < 256; i++) {
    S[i] = i;
  }

  let j = 0;
  for (let i = 0; i < 256; i++) {
    j = (j + S[i] + key.charCodeAt(i % key.length)) % 256;
    const tmp = S[i];
    S[i] = S[j];
    S[j] = tmp;
  }

  let i = 0;
  j = 0;
  const out = new Uint8Array(input.length);
  for (let n = 0; n < input.length; n++) {
    i = (i + 1) % 256;
    j = (j + S[i]) % 256;
    const tmp = S[i];
    S[i] = S[j];
    S[j] = tmp;
    out[n] = input[n] ^ S[(S[i] + S[j]) % 256];
  }

  return out;
}

function hexToBytes(hex: string): Uint8Array | null {
  const clean = hex.replace(/\s/g, '');
  if (clean.length === 0 || clean.length % 2 !== 0 || !/^[0-9a-fA-F]+$/.test(clean)) {
    return null;
  }

  const bytes = new Uint8Array(clean.length / 2);
  for (let i = 0; i < bytes.length; i++) {
    bytes[i] = parseInt(clean.substr(i * 2, 2), 16);
  }
  return bytes;
}

export function decryptLink(hex: string, key: string): string | null {
  const bytes = hexToBytes(hex);
  if (!bytes) {
    return null;
  }

  const decrypted = rc4(key, bytes);
  let plain = '';
  for (let i = 0; i < decrypted.length; i++) {
    plain += String.fromCharCode(decrypted[i]);
  }
  return plain;
}

export function parseTenantId(plain: string): string | null {
  const params = new URLSearchParams(plain);
  const empresa = params.get('e');
  const filial = params.get('f');

  if (!empresa || !filial) {
    return null;
  }

  return `${empresa},${filial}`;
}

export function tenantIdFromLink(hex: string, key: string): string | null {
  const plain = decryptLink(hex, key);
  if (!plain) {
    return null;
  }
  return parseTenantId(plain);
}
